// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const sessionStorageVersions: { readonly [key: string]: string } = {
  abnDetails: 'd2918298',
  academyCourses: 'daa590ef',
  academyInstructors: '6f4a29e8',
  academyPriceTiers: '8f9b15b4',
  accountProgress: '5154e12a',
  activeLanguages: '115ba804',
  adminChallenges: '5f1d845c',
  adminChargeUserFee: '36396f08',
  adminEnterprises: '3dfdaccc',
  adminExternalCredentialAllocationLogs: 'c7ffe7f2',
  adminExternalCredentialAllocations: '39cc25b5',
  adminExternalCredentialProviders: 'c2bb040d',
  adminIrisOffsiting: '66087bac',
  adminPcbBanManagement: '5e22eb3d',
  adminPools: '4fb2c234',
  adminProfileHistory: '9c1e0d5e',
  adminProjectDescriptionUpdate: '80ee25c3',
  adminProjects: 'e0fc173e',
  adminThreads: 'b938d9cd',
  adminUserDocumentSubmissions: '97cedc32',
  adminUserEnterprises: 'e431c180',
  adminUserPools: '1348e6e4',
  adminUserVerificationProcesses: 'dcbb5528',
  adminVerificationProcessTypes: 'ec47975d',
  agentSessions: '4a25d2bd',
  agents: 'ccd026eb',
  aiChangeTone: '4b3a5906',
  aiConsultantAudio: 'fd2e5f9c',
  aiConsultantChatTranscript: 'c25810c2',
  aiConsultant: '68129d3a',
  aiContinueWriting: 'af9af25a',
  aiConversationStarter: '31649810',
  aiEscalation: '2476e87e',
  aiFunctionCallHistory: '1874d9e1',
  aiImproveWriting: 'bf353880',
  aiPlayground: 'ba8d928c',
  aiPromptBuilders: 'fa084dd4',
  aiPromptPreview: '7f3b7dfd',
  aiPrompts: 'bfe8cb14',
  aiProofread: '19e6c336',
  aiRequest: '7c7faf3a',
  aiSmartCanvasMakeReal: '9737b974',
  aiSupportTypeModelConfiguration: '32be3e33',
  aiTaskFunctionDescriptions: '6fdf6b77',
  aiTaskModelConfiguration: '347290fb',
  allProjects: '8d0f8081',
  analytics: 'fd6e29ba',
  appInstallTracking: '66aae035',
  applicationScopes: '9947a1a7',
  articles: 'bc68b96a',
  banners: '5837f775',
  bidAwardDrafts: '1cae493a',
  bidAwardRevokeReasons: '64acf7c4',
  bidBuyerProjectFees: '1fe413c2',
  bidDescription: '97de0458',
  bidEditRequests: '0eb6bf1d',
  bidPitch: 'f3864045',
  bidRestrictions: '904ab8fd',
  bidScores: 'abf7389f',
  bidSummaries: '7d5ace0b',
  bidUpgradeFees: '4579a27f',
  bidVectorSearchAnnotations: 'f31e456d',
  bids: '3e0b9e91',
  billingAgreements: '74d85c38',
  blastChat: '1b32f295',
  blockedEmailsWhitelist: 'ebdd04a6',
  businessBuilderAttempt: '2ced05df',
  businessBuilderRandomIdeas: '69259dc2',
  businessBuilderTemplate: 'cd946b8f',
  campaigns: 'e9b8b0ac',
  canViewEmployerProfile: 'e4cd0623',
  canvas: 'e218071b',
  cartApprovals: '144b1843',
  cartItems: '04436d5c',
  carts: '15319b76',
  categoryPageContent: '6735adbf',
  categoryPageViewUsers: '42e39da3',
  certifications: '43fd8862',
  challenges: '5f1d845c',
  checkInSchedule: '996cc142',
  commentFeeds: '1ef2090f',
  comments: '070e9f87',
  contactUs: '24e86370',
  contacts: 'f638ab3f',
  contentCustomization: 'a637aa00',
  contestBudgetRanges: '68ec769e',
  contestCollaborations: '9d57cfb0',
  contestComments: 'f7c0d794',
  contestEngagement: 'a5593474',
  contestEntries: 'c509eeaf',
  contestEntryJudgeAssignments: '2725dd0e',
  contestEntryMessages: 'e7f58624',
  contestEntryOffers: '4b2413d5',
  contestFees: '418ae76b',
  contestFiles: 'a6232d99',
  contestHandoverContractDetails: '417c13cc',
  contestHandoverDisputes: '3f986b67',
  contestHandoverFiles: 'dab35c13',
  contestHandovers: 'e64e1b32',
  contestHasInvoices: 'da053572',
  contestInterestedFreelancers: '3fdb8a16',
  contestInterestedUsers: '24b5fb96',
  contestInvite: 'f06aea98',
  contestMessages: '9a9671b4',
  contestMinimumBudgetClassifications: '5927f183',
  contestPolls: 'd6f47e4b',
  contestPrizeDetails: '76b6865a',
  contestQuickviewEntries: 'ca219911',
  contestRubricSubmissions: 'ec5d4ae3',
  contestRubrics: '7d11f663',
  contestUserHasGivenFeedback: 'b5a67d52',
  contestViewContests: 'a6269bf5',
  contestViewEntries: '3271cdf0',
  contestViewEntryIds: '2fedeb6f',
  contestViewNewOrUpdatedEntries: '62b04480',
  contestsInterestedIn: '0782237f',
  contestsSelfInsights: '6d4a26f1',
  contests: '428271ca',
  contractDownloadUrls: '0b38a82a',
  contractSigningUrls: '9a0cfd26',
  contracts: '99a8bf7c',
  copilotChat: '27afff46',
  copilotEnquiries: '0278ee17',
  countries: '9f89d95c',
  countryLanguages: '2952e3c3',
  countryRequiresWhatsapp: 'f9fd3a2e',
  countryStates: '201562b4',
  currenciesIncludingExternal: '7de9b2df',
  currencies: '7de9b2df',
  currencyDetect: '7de9b2df',
  customBanners: 'da16e6be',
  customFieldInfoConfigurations: 'bbff3816',
  customFieldRelationships: '760f9349',
  customFieldValidations: 'b8695c25',
  dashboardPolls: 'df15b765',
  dashboardWidgets: '1b5a699c',
  deleteCommentsByUser: 'ed15a252',
  deleteFeedsByUser: '9e0a01f0',
  deliveryContactsSensitiveDetails: '78089414',
  deloitteSubscriberEmails: '2a956b3c',
  deloitteUserInfo: '6f940769',
  depositFees: 'f0c4ae35',
  depositPageVars: 'c9655864',
  developerApplications: '937e94bb',
  developerTokens: 'ae77f04e',
  discoverCollectionItemSaveCount: '46ee687e',
  discoverCollectionItems: 'c831f02e',
  discoverCollections: '299e0f1d',
  domains: 'c0e06272',
  driveFilePermissions: 'edacc1c0',
  driveFiles: 'd4ea6c18',
  educations: '8e7f7e3d',
  emailLeadCapture: '7df8449a',
  employerReputationsRehireRates: '5fc9a744',
  encodedUrl: '44db17c4',
  enterpriseBillingAgreementsBalance: '388804f8',
  enterpriseContact: '2daa0220',
  enterpriseLoadshiftAssetFinanceQuote: 'd0eecd52',
  enterpriseLoadshiftCancelGrandfatheredMembership: '8bf8f740',
  enterprises: '62aaf5c2',
  entryRestrictions: '855554dd',
  equipmentGroup: '4a0f9784',
  equipment: '401a6e03',
  exams: 'a490e8e6',
  exchangeRates: 'e3eddbf6',
  experiences: '1b1114cb',
  externalContactStatus: '47f540b6',
  externalReference: '5a6fbe55',
  feedMeta: 'a045ee70',
  feedPosts: '80883106',
  feed: '2015489c',
  feedback: '99269245',
  fieldServicesTalent: '6812eafa',
  financialReportingRecord: 'b266e0fc',
  findPageDetails: '0aae1d24',
  flareActionMap: '5ffe0c01',
  flareActions: '32d3fd4b',
  flareAdminLogs: '81701bfe',
  flareCheckpoints: '6a1f2291',
  flareRules: '25d46d18',
  flareRulesets: 'ec899720',
  freeRecruiterUpgrade: '97f72ba0',
  freelancerReputationsRehireRates: '5d900de7',
  freelancerReputations: '5f86ecc9',
  globalFleetContact: 'bf1cb95f',
  grants: '6824d1d8',
  groupActions: '19fec4d5',
  groupAttachments: 'd73d223e',
  groupFeed: '196997d4',
  groupMembers: 'f6f2babc',
  groupPermissions: 'ad399ac2',
  groupsSelf: '6b3c074a',
  groups: '6b3c074a',
  guidelines: '68e44b5a',
  harvardContacts: 'ccb97e37',
  hirePageDetails: 'e5d48224',
  hiremeCounteroffers: 'b6c922ce',
  hourlyContracts: '9d723795',
  hourlyProjectMilestoneFees: '06d688f2',
  insightsBids: '276a49cd',
  invitationBlocks: '852d4031',
  invitations: '25eaa9e9',
  invoices: '4a60d73f',
  ipContracts: 'b4a6b468',
  isFreeBids: '345c84fc',
  isLookingForWork: 'c90fd79b',
  issuingInstitution: '191c5080',
  jobClassifier: '2bde7c25',
  kycRejectReasons: 'bd1caf27',
  languageDetect: '8396cfb5',
  languages: 'b5e1f3de',
  llmBidSearchSuggestions: 'ceef272c',
  llmDirectorySearchAnnotations: '5da46c67',
  loadPriceEstimate: 'db715379',
  loadshiftSiteStats: 'b453cc6f',
  loginDevices: 'e1e8c745',
  manageViewContestHandovers: 'e51d9fa3',
  manageViewContests: 'ecd26fc2',
  manageViewHandovers: '9c70a39b',
  manageViewOngoingBids: '12f9cfe0',
  manageViewOngoingProjects: '21557649',
  manageViewOpenBids: '972809a1',
  manageViewOpenProjects: 'a3d09a0e',
  manageViewPastBids: '3ddb0415',
  manageViewPastProjects: 'a2715b3f',
  marketingMobileNumber: '6d57111b',
  membershipBenefits: '95f08f54',
  membershipDowngrades: '32f13ee4',
  membershipPackagePrices: 'e9b72f42',
  membershipPackages: '953ae3f2',
  membershipRenewals: 'e357585d',
  membershipSale: '55fbeb62',
  membershipSubscriptionHistory: 'aabf9e0c',
  membershipSubscription: 'f07571eb',
  membershipTrials: '13829b74',
  messageAttachments: 'c3f3b324',
  messages: '15784ec2',
  milestoneDrafts: 'f11b8885',
  milestoneRequests: '25ca5404',
  milestones: '62452ad8',
  modifyBidSellerFees: '403c3613',
  mygigsExpressionOfInterest: '91301a12',
  nativeExchangeRates: 'e3eddbf6',
  navigationTabs: 'ce9e650c',
  nearbyProjects: '7fb42601',
  newsfeed: '28159057',
  nextPreviousUsers: '84ead1aa',
  nextProjectRecommendations: '3cc469a5',
  notificationSettings: 'cf85f8d8',
  notificationsPreferences: '707e4156',
  notifications: '7b933131',
  onBehalfProjects: '1c57971f',
  onboardingEmailChange: '82d61e82',
  onlineOffline: 'f236f6f8',
  openGraphDetails: 'b6ab3861',
  operatingAreas: '63155645',
  partialSearchArticles: '00f64d05',
  paymentShareInterests: '2dfbb506',
  paymentShareMembersSpendingDetails: '44105cc7',
  paymentShareMembersSpentAmount: '3464028a',
  paymentShareMembers: 'df276338',
  paymentShareTeams: '916190d6',
  paymentShareWhitelistItems: '21b6c799',
  payoutAccountForm: 'b5f3ed7c',
  payoutAccounts: '36eeb560',
  payoutContext: 'faeba931',
  payoutLimitExemptions: '8353020d',
  payoutMethods: 'a7968866',
  pfSupportTickets: '1c736a06',
  pfpSkills: 'c385d285',
  pfpStatus: '4f2c9e47',
  pjpAssistantEnqueue: '9d60ace6',
  pools: '9763f0bf',
  portfolioItemsPositions: 'c90c65d9',
  portfolios: 'b002fc4d',
  postFiles: 'f226d954',
  postJobPageDescription: 'c2c093f8',
  postJobPageFormState: '40bf0339',
  postJobPageQuestions: 'eec66da2',
  predefinedDiscoverCollections: '299e0f1d',
  predictedSkills: '724d5f18',
  preferredBillingAgreements: '89d15a36',
  preferredSupportAgent: '81b3940d',
  profileCategories: '269dfb39',
  profileViewUsers: '12ba3835',
  profiles: '9a2fb59c',
  projectAiSummaries: 'eac04131',
  projectBidInfo: '488fbb8a',
  projectBidStats: '9d4f1055',
  projectBookmarks: '94b358c9',
  projectBudgetOptions: 'fe3aa365',
  projectCollaborations: '10c9a582',
  projectContestClassification: '56010c1a',
  projectDescriptionEntropyCompletion: 'fa666aaa',
  projectDescriptionEntropyQuestion: '08f4e34c',
  projectDescriptionInsertions: 'e4e5dec1',
  projectFeeInfo: '141ae845',
  projectFeedFailingContests: '88bc99dd',
  projectFeedFailingProjects: '88bc99dd',
  projectFeed: '88bc99dd',
  projectGroups: 'c11f5539',
  projectInvite: '96958cae',
  projectMatchInsights: 'ecabc86a',
  projectOffer: '6e9b8002',
  projectQualityDetails: 'e5dec798',
  projectSkillsPrediction: 'b90cd66f',
  projectSpamControls: 'd6a17d28',
  projectStats: '0bc17f0e',
  projectTitleEditRequest: 'a51a871f',
  projectUpgradeFees: '0dfb153e',
  projectViewBidderLocations: '9db55fdb',
  projectViewBidsSearchMetadata: '1a2e92b4',
  projectViewBids: '784b6454',
  projectViewProjects: '7d99aee9',
  projectViewUsers: '596d4178',
  projectWorkspaceLink: '479c4e7b',
  projectsSelfInsights: '811ba704',
  projectsSeo: '62bd9197',
  projects: '3e35da9d',
  prototyperPermissions: '7f05c920',
  pstnDialOut: '8e56ba93',
  pstnProxyAssignments: '45253e9b',
  publications: '32798a1b',
  quotationFundRequests: '4a0bc7d5',
  quotationFunds: '60344f9b',
  quotationItemRevisions: '33d45c31',
  quotationLogos: '2912f2c3',
  quotationRevisions: '795a13e8',
  quotationWhitelist: 'd5b9567e',
  reactionsTypeCount: 'c56cf285',
  realtimeMultimodalPjpReviewStepChat: 'afcc63eb',
  recentSavedSearchAlerts: '937bc55d',
  recommendedMembership: '85adb1b3',
  recommendedUpgrade: 'f8d027a7',
  recommendedUsernames: 'e46a2839',
  recruiterOptOut: 'f7106ebb',
  recurringBillingInformation: '7655694c',
  referralEligibility: '400612ac',
  referralInvitationCheck: '24eddef8',
  referralInvitations: '11a1700d',
  referralRecords: 'c84cfec4',
  referralToken: '5c8adf6f',
  registeredUserLookup: '32b0a3f2',
  retellPhoneCall: '0c7e89ff',
  retellProjectDetails: '36546790',
  retellToken: '6e395c18',
  reviewsSkills: '3ed5c1a7',
  reviews: '7608a243',
  salesTax: '48b3aad4',
  savedSearchContexts: '78519f25',
  scheduledSubscriptionPayments: '349093bf',
  searchActiveContests: '2ef70ed2',
  searchActiveLoads: 'e6579863',
  searchActiveProjects: '0d2bd171',
  searchAllProjects: '3e35da9d',
  searchArticles: '08fa95c0',
  searchClosedContests: '2ef70ed2',
  searchContestEntrants: '16c81d21',
  searchContestEntries: '3271cdf0',
  searchFreelancers: '59790ae0',
  searchKeywordProjects: '7fb1e85a',
  searchLocalFreelancers: 'a590d229',
  searchMyContacts: 'e62414e4',
  searchPreferredFreelancers: '2ff20967',
  searchProjectsSelf: 'e3cf7660',
  searchSavedFilters: '5098f6fc',
  searchThreads: 'ffcf9c5a',
  searchUsers: 'aced9d97',
  securityPhoneRequests: '524c1ee6',
  semDynamicPageContent: 'eaecef38',
  seoNavbar: '8e5b1dfa',
  serviceOfferingAttachments: 'fd5c0dc6',
  serviceOfferingBuyerHistories: 'a2e65d67',
  serviceOfferingShopCategories: 'a178d6fa',
  serviceOfferingShopCategoryServices: 'cff5d149',
  serviceOfferingShops: '5732a38c',
  serviceOfferingsWithOwnerDetails: '7e3b5888',
  serviceOfferings: '0447a9bc',
  sessionResolveReasons: 'f3c9f513',
  setPreferredFreelancersOnly: '0ff185bb',
  showcaseSource: '4d8ffadc',
  showcase: 'fcad74fe',
  similarFreelancers: 'a94c2497',
  similarShowcases: 'a94c2497',
  siteStats: '44179548',
  skillBundles: 'd00f17bc',
  skillsSubNavigation: 'b53931bf',
  skills: 'ba7c01d6',
  slaTasks: '60d8a5eb',
  startAiServiceChat: '56e1a243',
  subscriptionItems: 'a2db7875',
  suggestedSkills: '3b1aa909',
  superuserAgentSessions: '4a25d2bd',
  superuserBids: '3e0b9e91',
  superuserGrants: '6824d1d8',
  superuserGroupMembers: '1966fbd5',
  superuserGroupPermissions: '9abb162b',
  superuserGroups: '6b3c074a',
  superuserMessages: '15784ec2',
  superuserMilestones: '62452ad8',
  superuserProjectCollaborations: '10c9a582',
  superuserProjectNotes: 'c3e86343',
  superuserProjectViewAllProjects: '7d7c9bcb',
  superuserProjectViewProjects: 'd422a9f2',
  superuserProjectViewUsers: '91c9ae23',
  superuserRoles: 'a3fa279a',
  superuserSearchThreads: '5e3d65bc',
  superuserTaskGroupSections: '1fefd986',
  superuserTaskGroups: 'a0761120',
  superuserTasks: 'd4c461cf',
  superuserThreads: '5e3d65bc',
  supportAnswers: '2efc49de',
  supportArticleFeedbacks: '819a358a',
  supportArticles: '86417619',
  supportCategories: '23edde1b',
  supportCategoryArticles: '9ec47a89',
  supportChatBlock: '03666b12',
  supportChat: 'e7076c15',
  supportFeedbackIsAllowed: 'ec1a2ab2',
  supportFeedback: '0c8652b9',
  supportIssueCategories: 'b8069f2c',
  supportIssueCategoryArticles: '72c79e34',
  supportSessionNotes: '579f4abd',
  supportSuggestedArticles: 'f4359537',
  supportTags: '6baaa1a8',
  supportViewDetails: 'c5a5ca9a',
  swiftIdApplicant: '222fa47e',
  swiftIdApplicationStatus: '64d472b4',
  swiftIdApplicationSubmit: '74805171',
  swiftIdApplication: 'c28ddade',
  swiftIdEnum: 'b6639b8f',
  swiftIdInvitation: 'ac551750',
  swiftIdVerifySubmission: '6f4b47d5',
  tags: 'bcf4ea4b',
  taskGroupMembers: '892902b8',
  taskGroupSection: '1fefd986',
  taskGroup: 'a0761120',
  tasks: 'd4c461cf',
  taxOptOutOptions: 'bb90d828',
  taxStatement: 'd979cfa1',
  tax: '269061e1',
  teamInvitations: 'c8de15eb',
  teamMembers: '72012171',
  teams: '7fb26905',
  threadProjects: 'fe5805bc',
  threads: 'ffcf9c5a',
  timeTrackingDailyAggregates: 'cf0b1a2d',
  timeTrackingPunches: '9ff76aec',
  timeTrackingSession: '80a6c6bc',
  timelines: '0743398a',
  timezones: '97c596c8',
  toastNotifications: '66032edc',
  topSkills: '88edbb1b',
  trackingConsentMode: '273bc4a4',
  tracks: 'e4329979',
  transactionHistoryDetails: '2c9bcefd',
  transactionHistoryItems: '584221b1',
  unconfirmedAwards: '43d84cab',
  universities: '6864ec0a',
  usStates: 'f251a179',
  userAvailabilities: '558df69c',
  userAvailabilityAgent: 'b58fd403',
  userAvailabilityNotifyAgent: 'c976111e',
  userBalances: '19562fd9',
  userBidLimit: '02e82788',
  userBidOnRussianProjects: 'f799113d',
  userCalifornianStatuses: '811b2182',
  userCartRequiresEmailVerification: '534e3024',
  userCollaborations: '2f757606',
  userColleagues: '99d00da4',
  userConnectionsSearch: '8e92b7d9',
  userConnections: '2dc25bc8',
  userConsent: '1e357f44',
  userContactPhone: '8c9b259d',
  userContestCollaborationWhitelist: '507680d8',
  userCustomEmails: '247c86a0',
  userDepositMethods: '029e6d20',
  userDocumentSubmissions: '97cedc32',
  userEmailRequest: '86011c5e',
  userEnterprises: 'e431c180',
  userFees: '751f9413',
  userGiveGetDetails: 'f0ab8506',
  userHasDuplicateIp: '3f2340a4',
  userHasGivenFeedback: '9da27991',
  userInfo: 'e8ae1bc0',
  userInsignias: 'e393f744',
  userInteractions: 'b69a5eaa',
  userIpLocation: '75e3f8f9',
  userLastOnline: 'bdd8436d',
  userLocationDetails: 'd90fb02b',
  userNotificationPreferences: '4108e047',
  userNps: '7c0bc47c',
  userParsedResumes: '432d95a9',
  userPaymentControls: 'd4c61374',
  userPendingFunds: 'af370a4b',
  userPhoneVerificationBackoff: 'e1f3b584',
  userQualityDetails: '0dcc0040',
  userRecentProjectsAndContests: 'ea394add',
  userRequiresEmailVerification: 'e2f0beae',
  userRequiresGdpr: '1f192349',
  userRequiresPaymentVerification: '2c3c2819',
  userRequiresPhoneVerification: '2ca7cbd9',
  userRestrictions: 'f31c3242',
  userResumes: '1a461d39',
  userSaveLocation: '1f8f9039',
  userSettings: 'e5ca9765',
  userSkills: 'e25b853c',
  userTaxInfo: '75fc53b6',
  userTaxOptOutReasons: 'fd226fff',
  userTypeInfo: '946dad86',
  userVerificationProcesses: '6ce7575d',
  usersFollow: 'bbea0e01',
  usersLocation: '0a18f995',
  usersMfa: 'e4c9cb2c',
  usersProfileImage: 'e97d332d',
  usersProfile: 'a4e41277',
  usersRecommend: '0a80e5d1',
  usersSelf: 'b10c8ef4',
  usersTeamProfile: 'a4e41277',
  users: 'be088beb',
  verificationAddressDocumentTypes: 'd13b03dc',
  verificationCorporateKyc: 'd83e1fa9',
  verificationFiles: '95b77192',
  verificationIdTypes: '70151aa0',
  verificationProcessTypes: 'ec47975d',
  verificationRequest: 'dc622d40',
  videoVerificationRequest: '3b556aa9',
  videochats: 'cde01ec8',
  violationReports: '806e5051',
  webhooks: 'cada0b9d',
};
